module.exports = __webpack_public_path__ + "media/stylesheets/images/media/attracting_image2-9aeb79c23248c18882dd4ed603245183.jpg";